/* Copyright 2013 - 2024 Waiterio LLC */
import { css } from '@emotion/react'

export default css`
  label: semi-divider;
  border-bottom: 1px solid #e4e4e4;
  margin-left: 8px;
  margin-right: 8px;
`
